import { Stack, Typography } from '@mui/material';

const ReadonlyInfoItem = ({ label, value }) => (
  <Stack
    spacing={1} direction="row" sx={{
      alignItems: 'center'
    }}
  >
    <Typography color="textPrimary" variant="subtitle2">
      {label}:
    </Typography>

    <Typography color="textSecondary" variant="body2">
      {value}
    </Typography>
  </Stack>

);

export default ReadonlyInfoItem;
